import React, { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, TextArea } from "semantic-ui-react";
import { CloseIcon } from "../../Assets/Icons/svg";
import { selectTranslations } from "../../app/config/i18n/slice";

const DeletePermissionModal = ({
  isOpen = false,
  reason = "",
  setIsOpen = () => {},
  setReason = () => {},
  closeCallback = () => {},
  yesCallback = () => {},
  children,
  title = "",
}) => {
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  return (
    <Modal
      size="tiny"
      className="assets-modal procedure-modal"
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        closeCallback();
      }}
    >
      <div className="header-container red">
        <span className="assets-header">{t.common.delete + " " + title}</span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => {
              setIsOpen(false);
              closeCallback();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content>
        <div className="comment-container">
          <p className="assets-label mb-0">{children}</p>
          <label className="label-item">{t.common.reason}</label>
          <div className="add-comment">
            <TextArea
              className="comment-textarea"
              autoComplete="new-password"
              fluid
              rows={4}
              placeholder={t.common.deleteReason}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
      </Modal.Content>

      <div
        className={`modal-button-container mt-4 ${
          selectedLanguage == "en" ? "mr-8" : "ml-10"
        }`}
      >
        <button
          onClick={() => {
            setIsOpen(false);
            closeCallback();
          }}
          className="modal-form-action-button black"
        >
          {t.common.cancel}
        </button>

        <button
          onClick={() => {
            setIsOpen(false);
            yesCallback(reason);
          }}
          className="modal-form-action-button light-blue"
        >
          {t.common.delete}
        </button>
      </div>
    </Modal>
  );
};

export function useDeletePermissionModal() {
  const [isOpen, setIsOpen] = useState(false);

  const DeletePermissionModalCallback = useCallback(
    ({ children, closeCallback, yesCallback, title, setReason, reason }) => (
      <DeletePermissionModal
        isOpen={isOpen}
        reason={reason}
        title={title}
        setIsOpen={setIsOpen}
        setReason={setReason}
        closeCallback={closeCallback}
        yesCallback={() => yesCallback(reason)}
      >
        {children}
      </DeletePermissionModal>
    ),
    [isOpen]
  );
  return useMemo(
    () => ({
      setDeletePermissionModal: setIsOpen,
      DeletePermissionModal: DeletePermissionModalCallback,
    }),
    [setIsOpen, DeletePermissionModalCallback]
  );
}

export default useDeletePermissionModal;
